import s from "./ratingSlider.module.css";
import RadioInput from "./RadioInput";
import {useRatingSlider} from "./useRatingSlider";
import {useAppContext} from "../../../../../contexts";

const RatingSlider = (props) => {
    // Destructured props
    const {
        formValues,
        handleChange
    } = props;

    // Component logic data
    const componentProps = useRatingSlider();

    // Destructured component logic data
    const {
        hoveredOption,
        handleMouseEvent
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // All the available rating options
    const ratingOptions =
        Array.from(Array(11).keys()).map(item => {
            return (
                <RadioInput
                    key={item}
                    rating={item}
                    formValues={formValues}
                    handleChange={handleChange}
                    handleMouseEvent={handleMouseEvent}
                />
            )
        });

    const WIDTHS_ENUM = {
        0: "w-0",
        1: "w-[13%]",
        2: "w-[22%]",
        3: "w-[32%]",
        4: "w-[41%]",
        5: "w-[50%]",
        6: "w-[60%]",
        7: "w-[68%]",
        8: "w-[78%]",
        9: "w-[87%]",
        10: "w-[100%]",
    }

    const barWidth =
        (hoveredOption || formValues.fsRating) ? WIDTHS_ENUM[hoveredOption || formValues.fsRating] : "w-[2.5%]";

    return (
        <div className={s.root}>
            <div className={"w-full flex flex-row justify-between items-center"}>
                {ratingOptions}
            </div>

            <div className={s.sliderRoot}>
                <div className={`${s.frontBar} ${highContrast ? s.dmFrontBar : s.defaultFrontBar} ${barWidth}`} />
                <div className={`${s.backBar} ${highContrast ? s.dmBackBar : s.defaultBackBar}`} />
            </div>
        </div>
    )
}

export default RatingSlider;
